<section class="playground">
  <h2 class="playground__heading">Tooltip</h2>
  <p class="playground__hint"><code>common-tooltip</code> wrapper de Angular Material Tooltip.</p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>text</span>
        <input type="text" [(ngModel)]="text" />
      </label>
      <label class="playground__field">
        <span>icon</span>
        <input type="text" [(ngModel)]="icon" />
      </label>
      <label class="playground__field">
        <span>position</span>
        <select [(ngModel)]="position">
          <option *ngFor="let p of positions" [value]="p">{{ p }}</option>
        </select>
      </label>
      <label class="playground__field playground__field--checkbox">
        <input type="checkbox" [(ngModel)]="disabled" />
        <span>disabled</span>
      </label>
    </div>

    <div class="playground__preview-box">
      <common-tooltip [text]="text" [position]="position" [disabled]="disabled" [icon]="icon"></common-tooltip>
    </div>
  </div>
</section>
